import { render, staticRenderFns } from "./platformInfoManagement.vue?vue&type=template&id=b66f1cde&scoped=true"
import script from "./platformInfoManagement.vue?vue&type=script&lang=js"
export * from "./platformInfoManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=b66f1cde&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/tableList.scss?vue&type=style&index=1&id=b66f1cde&prod&lang=scss&scoped=true&external"
import style2 from "./platformInfoManagement.vue?vue&type=style&index=2&id=b66f1cde&prod&lang=scss&scoped=true"
import style3 from "./platformInfoManagement.vue?vue&type=style&index=3&id=b66f1cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66f1cde",
  null
  
)

export default component.exports